import React from "react";

const CandidateDashboard = () => {
  return (
    <div>
      <h1>This is candidate dashboard</h1>
    </div>
  );
};

export default CandidateDashboard;
